import { CR_API_ENDPOINTS } from '../constants';
import { apiService } from './api.service';
import { Poi } from '../types';

class PoiService {
  async getAllPoi(): Promise<Poi[]> {
    try {
      return await apiService.get<Poi[]>(CR_API_ENDPOINTS.POI);
    } catch (error) {
      throw new Error(`Failed to fetch POI options: ${error}`);
    }
  }

  async getPoiById(id: string): Promise<Poi> {
    try {
      return await apiService.get<Poi>(`${CR_API_ENDPOINTS.POI}/${id}`);
    } catch (error) {
      throw new Error(`Failed to fetch POI option: ${error}`);
    }
  }

  async createPoi(poiData: {
    model: string;
  }): Promise<Poi> {
    try {
      return await apiService.post<Poi>(CR_API_ENDPOINTS.POI, poiData);
    } catch (error) {
      throw new Error(`Failed to create POI: ${error}`);
    }
  }
}

export const poiService = new PoiService();